export const METRICS_TIMEZONES = ['UTC', 'EDT', 'EST', 'CST', 'CDT'] as const;

export type MetricsTimezone = (typeof METRICS_TIMEZONES)[number];

export function isMetricsTimezone(value: string): value is MetricsTimezone {
  return METRICS_TIMEZONES.includes(value as MetricsTimezone);
}
